module.exports = __webpack_public_path__ + "a71ca1db3bde5bd2632c28fdde2d27a6.svg";